import { useCallback, useState } from 'react';
import { DragEndEvent } from '@dnd-kit/core';
import { DealRoomTopNodes } from 'models/DealRoom';
import { arrayMove } from '@dnd-kit/sortable';
import api from 'api';
import usePress from 'hooks/usePress';

export default function useReordering(
  dealRoomId: string,
  dealRoomTopNodes: DealRoomTopNodes[],
) {
  const [isReordering, setIsReordering] = useState(false);

  const [items, setItems] = useState(
    dealRoomTopNodes.map(({ dataRoomNode }) => dataRoomNode),
  );

  const onDragEnd = useCallback(
    (e: DragEndEvent) => {
      const { active, over } = e;

      if (active.id === over.id) return;

      setItems((items) => {
        const oldIndex = items.findIndex(({ _id }) => _id === active.id);
        const newIndex = items.findIndex(({ _id }) => _id === over.id);

        const newOrder = arrayMove(items, oldIndex, newIndex);

        api.portfolio.seller.reorderTopDataRoomNodes(
          dealRoomId,
          newOrder.map((el, index) => ({
            dataRoomNodeId: el._id,
            orderNumber: index,
          })),
        );

        return newOrder;
      });
    },
    [dealRoomId],
  );

  const reorderButtonEvents = usePress({
    onPressStart: () => setIsReordering(true),
    onPressEnd: () => setIsReordering(false),
  });

  return { isReordering, items, reorderButtonEvents, onDragEnd };
}
